import axios from 'axios'
import cookie from 'react-cookies'
import apiUrl from '../ApiUrl'
import moment from 'moment'
import { notify } from 'react-notify-toast'

// import { withCookies, Cookies } from 'react-cookie'
// import { useCookies } from 'react-cookie'

import Cookies from 'js-cookie'

export const hasDiet = async () => {
  let hasDiet = false

  await axios
    .get(`${apiUrl}/api/diets/has_diet/`, {
      headers: {
        Authorization: 'Bearer ' + Cookies.get('accessToken'),
      },
    })
    .then((response) => {
      if (response.data.has_diet) {
        hasDiet = true
      }
    })
    .catch(({ response, error }) => {
      if (!response.data.has_diet) {
        hasDiet = false
      }
    })

  return hasDiet
}

export const litOfDiets = async () => {
  let diets

  await axios
    .get(`${apiUrl}/api/diets/`, {
      headers: {
        Authorization: 'Bearer ' + Cookies.get('accessToken'),
      },
    })
    .then((response) => {
      if (response.data) {
        diets = response.data
      }
    })
    .catch(({ response, error }) => {})

  return diets
}

export const setDiet = async (dietId) => {
  const setUserDietConfig = {
    method: 'post',
    url: `${apiUrl}/api/diets/set_diet/`,
    data: {
      diet_type: dietId,
    },
    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(setUserDietConfig)
    .then((response) => {})
    .catch((error, response) => {
      if (response.status === 401) {
        // refreshToken()
        // patchUserData(name, show_intro, is_profile_complete, userId)
      } else {

      }
    })
}

export const patchDiet = async (amount, protein, carbs, fat) => {
  const setUserDietConfig = {
    method: 'patch',
    url: `${apiUrl}/api/diets/update_calories_goal/ `,
    data: {
      calorie: {
        amount: amount,
        protein: protein,
        carbs: carbs,
        fat: fat,
      },
    },
    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(setUserDietConfig)
    .then((response) => {
      notify.show('Poprawnie zapisano dane.', 'success', 2000)
    })
    .catch((error, response) => {
      if (response.status === 401) {
        // refreshToken()
        // patchUserData(name, show_intro, is_profile_complete, userId)
      } else {

      }
    })
}

export const getUserDailyBalance = async (date) => {
  let dailyBalance
  const getUserDailyBalanceConfig = {
    method: 'get',
    url: `${apiUrl}/api/diets/daily_balances/?date=${date}`,
    // data: {
    //   date: date,
    // },
    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(getUserDailyBalanceConfig)
    .then((response) => {
      dailyBalance = response.data
    })
    .catch((error, response) => {})

  return dailyBalance
}

export const getUserDietData = async () => {
  let dailyBalanceInfo

  const getUserDailyBalanceConfig = {
    method: 'get',
    url: `${apiUrl}/api/diets/get_diet/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(getUserDailyBalanceConfig)
    .then((response) => {
      dailyBalanceInfo = response.data
    })
    .catch((error, response) => {

    })

  return dailyBalanceInfo
}

export const getMealsList = async () => {
  let mealsList

  const getMealsListConfig = {
    method: 'get',
    url: `${apiUrl}/api/diets/meals/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(getMealsListConfig)
    .then((response) => {
      mealsList = response.data
    })
    .catch((error, response) => {
      console.log(response)
    })

  return mealsList
}

export const getSpecificMeal = async (mealId) => {
  let specificMeal

  const getSpecificMealConfig = {
    method: 'get',
    url: `${apiUrl}/api/diets/meals/${mealId}/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(getSpecificMealConfig)
    .then((response) => {
      specificMeal = response.data
    })
    .catch((error, response) => {})

  return specificMeal
}

export const addMealToDailyBalance = async (mealId, mealType, date) => {
  let specificMeal
  let mealTypeInt

  switch (mealType) {
    case 'Śniadanie':
      mealTypeInt = 1
      break
    case 'II śniadanie':
      mealTypeInt = 2
      break
    case 'Obiad':
      mealTypeInt = 3
      break
    case 'Przekąska':
      mealTypeInt = 5
      break
    case 'Kolacja':
      mealTypeInt = 4
      break
  }

  const addMealToDailyBalanceConfig = {
    method: 'post',
    url: `${apiUrl}/api/diets/daily_balances/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
    data: {
      meal: mealId,
      meal_type: mealTypeInt,
      date_added: date,
    },
  }

  await axios(addMealToDailyBalanceConfig)
    .then((response) => {
      specificMeal = response.data

      notify.show('Poprawnie dodano posiłek do diety.', 'success', 2000)
    })
    .catch((error, response) => {})

  return specificMeal
}

export const removeSpecificMeal = async (dailyBalanceMealId) => {
  let specificMeal

  const removeSpecificMealConfig = {
    method: 'delete',
    url: `${apiUrl}/api/diets/daily_balances/${dailyBalanceMealId}/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(removeSpecificMealConfig)
    .then((response) => {
      specificMeal = response.data
    })
    .catch((error, response) => {})

  return specificMeal
}

export const addMealToCart = async (mealId, date) => {
  const addMealToCartConfig = {
    method: 'post',
    url: `${apiUrl}/api/diets/shopping_cart/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
    data: {
      ingredient_detail: mealId,
      date: date,
    },
  }

  await axios(addMealToCartConfig)
    .then((response) => {
      notify.show('Poprawnie dodano produkt do koszyka', 'success', 2000)
    })
    .catch((error, response) => {
      console.log(response)
    })
}

export const removeMealFromCart = async (mealId) => {
  const removeMealFromCartConfig = {
    method: 'delete',
    url: `${apiUrl}/api/diets/shopping_cart/${mealId}/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(removeMealFromCartConfig)
    .then((response) => {
      notify.show('Poprawnie usunięto produkt z koszyka', 'success', 2000)
    })
    .catch((error, response) => {
      console.log(response)
    })
}

export const checkMealInCart = async (mealId) => {
  const checkMealInCartConfig = {
    method: 'patch',
    url: `${apiUrl}/api/diets/shopping_cart/${mealId}/`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(checkMealInCartConfig)
    .then((response) => {
      notify.show(
        'Poprawnie zmieniono stan pozycji w koszyku.',
        'success',
        2000
      )
    })
    .catch((error, response) => {
      console.log(response)
    })
}

export const getCartItems = async (date) => {
  let cartItems

  const getCartItemsConfig = {
    method: 'get',
    url: `${apiUrl}/api/diets/shopping_cart/?date=${date}`,

    headers: {
      Authorization: 'Bearer ' + Cookies.get('accessToken'),
    },
  }

  await axios(getCartItemsConfig)
    .then((response) => {
      cartItems = response.data
    })
    .catch((error, response) => {
      console.log(response)
    })

  return cartItems
}
